"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickOutside = useClickOutside;

var _react = require("react");

var _noop = _interopRequireDefault(require("../../utils/noop"));

var _useLoggerDependencies = require("../useLoggerDependencies");

var checkIsDescendantOrRoot = function checkIsDescendantOrRoot(_ref) {
  var ignoreClicksInsideRefs = _ref.ignoreClicksInsideRefs,
      target = _ref.target;
  return ignoreClicksInsideRefs.some(function (ref) {
    var _ref$current;

    return (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(target)) || ref.current === target;
  });
};

var addEventListener = function addEventListener(target, event, fn) {
  target.addEventListener(event, fn);
  return function () {
    target.removeEventListener(event, fn);
  };
};
/**
 * Реализация в большей степени основана на библиотеки react-outside-click-handler
 * https://github.com/airbnb/react-outside-click-handler/blob/master/src/OutsideClickHandler.jsx
 */


function useClickOutside(_ref2) {
  var active = _ref2.active,
      ignoreClicksInsideRefs = _ref2.ignoreClicksInsideRefs,
      _ref2$handler = _ref2.handler,
      handler = _ref2$handler === void 0 ? _noop.default : _ref2$handler;
  var removeMouseUp = (0, _react.useRef)(null);
  var removeMouseDown = (0, _react.useRef)(null);

  var _useLoggerDependencie = (0, _useLoggerDependencies.useLoggerDependencies)({
    active: active,
    ignoreClicksInsideRefs: ignoreClicksInsideRefs,
    handler: handler,
    scopeName: 'useClickOutside'
  }),
      detectedChangedProps = _useLoggerDependencie.detectedChangedProps,
      unmountTrigger = _useLoggerDependencie.unmountTrigger;

  (0, _react.useEffect)(function () {
    if (!active) {
      return;
    }

    var onMouseUp = function onMouseUp(event) {
      var target = event.target;

      if (removeMouseUp.current) {
        removeMouseUp.current();
        removeMouseUp.current = null;
      }

      if (!checkIsDescendantOrRoot({
        ignoreClicksInsideRefs: ignoreClicksInsideRefs,
        target: target
      })) {
        handler(event);
      }
    };

    var onMouseDown = function onMouseDown(event) {
      var target = event.target;

      if (!checkIsDescendantOrRoot({
        ignoreClicksInsideRefs: ignoreClicksInsideRefs,
        target: target
      })) {
        if (removeMouseUp.current) {
          removeMouseUp.current();
          removeMouseUp.current = null;
        }

        removeMouseUp.current = addEventListener(document, 'mouseup', onMouseUp);
      }
    };

    var addMouseDownEventListener = function addMouseDownEventListener() {
      removeMouseDown.current = addEventListener(document, 'mousedown', onMouseDown);
    };

    addMouseDownEventListener();
    detectedChangedProps(); // eslint-disable-next-line consistent-return

    return function () {
      if (removeMouseDown.current) {
        removeMouseDown.current();
      }

      if (removeMouseUp.current) {
        unmountTrigger();
        removeMouseUp.current();
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, handler, ignoreClicksInsideRefs]);
}